import { createContainer } from '@evyweb/ioctopus';

import { createCouponModule } from './modules/coupon.js';
import { createDefinitionModule } from './modules/definition.js';
import { createDrawSubscriptionModule } from './modules/drawSubscription.js';
import { createInfrastructureModule } from './modules/infrastructure.js';
import { createMarketplaceGroupsClientModule } from './modules/marketplace-groups-client.js';
import { wagerClientModule } from './modules/wagerClient.js';
import { createWalletModule } from './modules/wallet.js';
import { diSymbolMap, type DiSymbolMapType } from './types.js';

const applicationContainer = createContainer();

applicationContainer.load(Symbol('InfrastructureModule'), createInfrastructureModule());
applicationContainer.load(Symbol('CouponModule'), createCouponModule());
applicationContainer.load(Symbol('DefinitionModule'), createDefinitionModule());
applicationContainer.load(Symbol('DrawSubscriptionModule'), createDrawSubscriptionModule());
applicationContainer.load(Symbol('WagerClientModule'), wagerClientModule());
applicationContainer.load(Symbol('WalletModule'), createWalletModule());
applicationContainer.load(Symbol('MarketplaceGroupsModule'), createMarketplaceGroupsClientModule());

/**
 * Retrieves an instance from the dependency injection container for the client.
 *
 * @param symbol The symbol key used to identify the instance in the DI container.
 * @returns The instance associated with the provided symbol key.
 */
export function getInstanceClient<TKey extends keyof typeof diSymbolMap>(symbol: TKey): DiSymbolMapType[TKey] {
  return applicationContainer.get(diSymbolMap[symbol]);
}
